"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _PlayerFactory2 = _interopRequireDefault(require("../models/PlayerFactory"));
var _WindowsMediaPlayer = _interopRequireDefault(require("./WindowsMediaPlayer"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-plusplus */
/**
 * Windows Media Player ActiveX control ID.
 *
 * Documentation:
 *  https://docs.microsoft.com/en-us/windows/win32/wmp/simple-example-of-scripting-in-a-web-page#adding-the-object-tag
 *
 * @type {string}
 */
var WindowsMediaPlayerClassId = 'clsid:6BF52A52-394A-11d3-B153-00C04F79FAA6';
var WindowsMediaPlayerFactory = exports["default"] = /*#__PURE__*/function (_PlayerFactory) {
  (0, _inherits2["default"])(WindowsMediaPlayerFactory, _PlayerFactory);
  function WindowsMediaPlayerFactory(blankMP3Url) {
    var _this;
    (0, _classCallCheck2["default"])(this, WindowsMediaPlayerFactory);
    _this = _callSuper(this, WindowsMediaPlayerFactory);
    _this.blankMP3Url = blankMP3Url;
    _this.playerInstanceCount = 0;
    return _this;
  }
  (0, _createClass2["default"])(WindowsMediaPlayerFactory, [{
    key: "createPlayer",
    value: function createPlayer() {
      var wmpPlayerId = 'wmp_player_' + this.playerInstanceCount;
      this.playerInstanceCount++;
      var containerElement = document.createElement('div');
      var objectElement = document.createElement('object');
      objectElement.setAttribute('id', wmpPlayerId);
      objectElement.setAttribute('width', '0');
      objectElement.setAttribute('height', '0');
      objectElement.setAttribute('classId', WindowsMediaPlayerClassId);
      containerElement.appendChild(objectElement);
      document.body.appendChild(containerElement);
      return new _WindowsMediaPlayer["default"](wmpPlayerId, containerElement, this.blankMP3Url);
    }
  }]);
  return WindowsMediaPlayerFactory;
}(_PlayerFactory2["default"]);
//# sourceMappingURL=WindowsMediaPlayerFactory.js.map